import Img from 'gatsby-image';
import styled from 'styled-components';

import UI from '#front-credpago';

import globals from '../../globals';

const { containerMaxWidth } = globals;

export const Wrapper = styled.div`
  background: #f1f1f1;
  display: flex;

  @media ${UI.globals.mediaqueries.md} {
    padding: 10px 0px 10px 0px;
  }
`;

export const Container = styled.div`
  width: 100%;
  max-width: calc(${containerMaxWidth} + 40px);
  margin: 0 auto;
  align-self: center;
  position: relative;
`;

export const WrapperImg = styled.div`
  position: relative;
`;

export const ImgBuilding = styled(Img)`
  position: absolute;
  right: 20px;
  top: 20px;

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
    right: 0px;
    top: 20px;
  }

  @media ${UI.globals.mediaqueries.md} {
    top: 114px;
    left: -250px;
    width: 190%;
  }

  @media ${UI.globals.mediaqueries.lg} {
    top: 20px;
    left: -250px;
    width: 150%;
  }

  @media screen and (min-width: 769px) and (max-width: 1024px) {
    top: 76px;
  }
`;

export const ColumnImg = styled(UI.Col)`
  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
    order: 1;
    padding: 0px 50px;
  }
`;

export const Description = styled.p`
  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
    text-align: right;
  }
`;

export const WrapperLogoCredBtg = styled.div`
  margin-top: 40px;

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
    display: flex;
    justify-content: center;
  }
`;
